import styled from 'styled-components';
import { CancelCircleIcon, TickCircleIcon } from '@root/styles/icons';

export const CheckIcon = styled(TickCircleIcon)`
  color: ${({ theme }) => theme.customColors.primary};
  margin-right: ${({ theme }) => theme.spaces.space4};
`;

export const ErrorIcon = styled(CancelCircleIcon)`
  color: ${({ theme }) => theme.semanticColors.redDark};
  margin-right: ${({ theme }) => theme.spaces.space4};
`;
